<template>
  <wtFormRight>
    <!-- -TOOLBARS -->
    <template slot="toolbars">
      <Toolbars
        :objProps="objItem"
        :objPropsData="objItemData"
        :urlServices="urlServices"
        :primary_key="primary_key"
        :nameObjData="nameObjData"
        :requiredEndDt="requiredEndDt"
        :noDelete="noDelete"
      />
    </template>

    <!-- VIEW TABLE -->
    <template slot="table" v-if="showGrid">
      <BpmProcessGrid @selectedBpmProcess="objRowSelected = $event"></BpmProcessGrid>
    </template>

    <!-- VIEW FORM -->
    <template slot="form" v-if="!showGrid">
      <b-form class="text-uppercase">
        <div class="form-row">
          <div class="form-group col-md-6" v-if="!objItem.bpm_process_id">
            <label for="bpm_process_process_name">Process Name</label>
            <input
              type="text"
              class="form-control"
              id="bpm_process_process_name"
              v-model.trim="objItemData.process_name"
              placeholder="example_name"
              :readonly="objItem.bpm_process_id"
            />
          </div>
          <div class="form-group col-md-6">
            <label for="bpm_process_process_label">Process Label</label>
            <input
              type="text"
              class="form-control"
              id="bpm_process_process_label"
              v-model.trim="objItemData.process_label"
              placeholder="Example Label"
            />
          </div>
          <div class="form-group col-md-6">
            <!-- TIME STAMP INIT -->
            <label for="bpm_process_init_dt" v-if="!objItem.bpm_process_id">init. Date</label>
            <input
              type="date"
              class="form-control"
              id="bpm_process_init_dt"
              v-model.trim="objItemData.init_dt"
              v-if="!objItem.bpm_process_id"
            />

            <!-- TIME STAMP END -->
            <label for="bpm_process_end_dt" v-if="objItem.bpm_process_id">End Date</label>
            <input
              type="date"
              class="form-control"
              id="bpm_process_end_dt"
              v-model.trim="objItemData.end_dt"
              v-if="objItem.bpm_process_id"
            />
          </div>
        </div>
      </b-form>
    </template>
  </wtFormRight>
</template>
<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

/* COMPONENTS - LAYOUT */
import wtFormRight from "@/components/forms/wtFormRight";
import Toolbars from "@/components/widgets/Toolbars";

/* COMPONENTS - PAGE */
import BpmProcessGrid from "./BpmProcessGrid";

export default {
  name: "BpmProcess",

  /* COMPONENTS IN USE */
  components: { wtFormRight, Toolbars, BpmProcessGrid },

  /* COMPUTED VARIABLES */
  computed: {
    showGrid() {
      return this.$store.state.layout.showGrid;
    },
    urlServicesStore() {
      return this.$store.state.urlServicesStore;
    },
    objShared() {
      return this.$store.state.objShared;
    },
    objSelected() {
      return this.$store.state.objSelected;
    },
    objProcess() {
      return this.$store.state.objProcess;
    },
    action() {
      return this.$store.state.action;
    }
  },

  /* VARIABLES */
  data: function() {
    return {
      /* Controls */
      urlServices: "chameleon-ds/api/internal/bpm-process",
      primary_key: "bpm_process_id",

      /* Objects Page */
      objItem: {},
      objItemData: {},
      objRowSelected: {},
      nameObjData: "bpm_process_data",
      requiredEndDt: true,
      noDelete: true

      /* Others Query */
    };
  },

  /* METHODS */
  methods: {
    load(objItem) {
      this.$store.commit("setShowLoading", true);
      this.$store.commit("setShowGrid", false);

      const param = {};
      param[`${this.primary_key}`] = objItem[`${this.primary_key}`];
      const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find/`;

      axios.post(url, param).then(res => {
        this.objItem = res.data[0];
        this.objItemData = this.objItem[`${this.nameObjData}`];
        this.$store.commit("setShowLoading", false);
      });
    }
  },

  /* WATCH */
  watch: {
    objRowSelected() {
      this.load(this.objRowSelected);
      this.$store.commit("setAction", "modify");
    },
    /* pay attention, this watcher has been changed */
    action() {
      if (this.urlServicesStore === this.urlServices) {
        if (this.action === "reset") {
          this.objItem = {};
          this.objItemData = {};
        }
      }
    },
    showGrid() {
      if (this.showGrid) {
        this.objItem = {};
        this.objItemData = {};
      }
    }
  }
};
</script>